import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';
import { getColor } from 'ui/icons/utils';
import { colors } from 'ui/theme/colors';

export const QuickActions24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M6.17647 4.58824H17.8235C18.2448 4.58824 18.6487 4.75557 18.9466 5.05342C19.2444 5.35127 19.4118 5.75524 19.4118 6.17647V17.8235C19.4118 18.2448 19.2444 18.6487 18.9466 18.9466C18.6487 19.2444 18.2448 19.4118 17.8235 19.4118H6.17647C5.75524 19.4118 5.35127 19.2444 5.05342 18.9466C4.75557 18.6487 4.58824 18.2448 4.58824 17.8235V6.17647C4.58824 5.75524 4.75557 5.35127 5.05342 5.05342C5.35127 4.75557 5.75524 4.58824 6.17647 4.58824ZM3 6.17647C3 5.33402 3.33466 4.52607 3.93037 3.93037C4.52607 3.33466 5.33402 3 6.17647 3H17.8235C18.666 3 19.4739 3.33466 20.0696 3.93037C20.6653 4.52607 21 5.33402 21 6.17647V17.8235C21 18.666 20.6653 19.4739 20.0696 20.0696C19.4739 20.6653 18.666 21 17.8235 21H6.17647C5.33402 21 4.52607 20.6653 3.93037 20.0696C3.33466 19.4739 3 18.666 3 17.8235V6.17647ZM15.3247 7.64929C15.433 7.46962 15.4659 7.25437 15.416 7.05056C15.3662 6.84675 15.2377 6.67096 15.0587 6.56157C14.8796 6.45219 14.6646 6.41811 14.4605 6.46677C14.2564 6.51543 14.0798 6.64289 13.9694 6.82129L8.14588 16.3507C8.03754 16.5304 8.00471 16.7456 8.05456 16.9494C8.10441 17.1532 8.23288 17.329 8.41193 17.4384C8.59097 17.5478 8.80603 17.5819 9.01012 17.5332C9.21421 17.4846 9.39075 17.3571 9.50118 17.1787L15.3247 7.64929Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
